import { create } from 'zustand'

interface LoadingState {
  isLoading: boolean
  message: string | null
  setLoading: (loading: boolean, message?: string | null) => void
}

export const useLoadingStore = create<LoadingState>((set) => ({
  isLoading: false,
  message: null,
  setLoading: (loading: boolean, message: string | null = null) => 
    set({ isLoading: loading, message }),
}))

